import { ENTITY_TYPE } from 'modules/app/constants';
import { actionTypeFormatter } from 'modules/sockets/actionTypes';
import { SOCKET_ACTION, SOCKET_TOPIC } from 'modules/sockets/constants';

export const FETCH_CONTACT_LISTS = 'CONTACT_LISTS/FETCH_REQUEST';
export const FETCH_CONTACT_LISTS_SUCCESS = 'CONTACT_LISTS/FETCH_SUCCESS';

export const FETCH_CONTACT_LIST = 'CONTACT_LIST/FETCH_REQUEST';
export const FETCH_CONTACT_LIST_SUCCESS = 'CONTACT_LIST/FETCH_SUCCESS';
export const FETCH_CONTACT_LIST_FAILURE = 'CONTACT_LIST/FETCH_FAILURE';

export const CREATE_CONTACT_LIST = 'CONTACT_LIST/POST_REQUEST';
export const CREATE_CONTACT_LIST_SUCCESS = 'CONTACT_LIST/POST_SUCCESS';

export const OPEN_CREATE_CONTACT_LIST = 'CONTACT_LIST/MODAL/CREATION/OPEN';
export const CLOSE_CREATE_CONTACT_LIST = 'CONTACT_LIST/MODAL/CREATION/CLOSE';

export const UPDATE_CONTACT_LIST = 'CONTACT_LIST/PUT_REQUEST';
export const UPDATE_CONTACT_LIST_SUCCESS = 'CONTACT_LIST/PUT_SUCCESS';

export const DELETE_CONTACT_LIST = 'CONTACT_LIST/DELETE_REQUEST';
export const DELETE_CONTACT_LIST_SUCCESS = 'CONTACT_LIST/DELETE_SUCCESS';
export const DELETE_CONTACT_LIST_FAILURE = 'CONTACT_LIST/DELETE_FAILURE';

export const OPEN_EXPORT = 'CONTACT_LIST/EXPORT/OPEN';
export const CLOSE_EXPORT = 'CONTACT_LIST/EXPORT/CLOSE';

export const EXPORT_CONTACT_LIST = 'CONTACT_LIST/EXPORT_REQUEST';
export const EXPORT_CONTACT_LIST_SUCCESS = 'CONTACT_LIST/EXPORT_SUCCESS';

export const ADD_CONTACTS = 'CONTACT_LIST/ADD_CONTACTS_REQUEST';
export const ADD_CONTACTS_SUCCESS = 'CONTACT_LIST/ADD_CONTACTS_SUCCESS';

export const OPEN_ADD_CONTACTS_MODAL = 'CONTACT_LIST/ADD_CONTACTS_MODAL/OPEN';
export const CLOSE_ADD_CONTACTS_MODAL = 'CONTACT_LIST/ADD_CONTACTS_MODAL/CLOSE';

/** FILTERS */
export const SET_CONTACT_LIST_DASHBOARD_FILTER = 'CONTACT_LIST/DASHBOARD/FILTERS/SET_ONE';
export const SET_CONTACT_LIST_DASHBOARD_FILTERS = 'CONTACT_LIST/DASHBOARD/FILTERS/SET_MANY';
export const REMOVE_CONTACT_LIST_DASHBOARD_FILTER = 'CONTACT_LIST/DASHBOARD/FILTERS/REMOVE_ONE';
export const CLEAR_CONTACT_LIST_DASHBOARD_FILTER = 'CONTACT_LIST/DASHBOARD/FILTERS/CLEAR';

export const DETAILS_INITIALIZED = 'CONTACT_LIST/DETAILS/INITIALIZED';

export const WS_CONTACT_LIST_STATS_UPDATE = actionTypeFormatter(
  SOCKET_TOPIC.DETAILS,
  ENTITY_TYPE.CONTACT_LIST,
  SOCKET_ACTION.CONTACT_LIST_STATS_UPDATE
);

export const WS_CONTACT_LIST_UPDATED = actionTypeFormatter(
  SOCKET_TOPIC.DETAILS,
  ENTITY_TYPE.CONTACT_LIST,
  SOCKET_ACTION.CONTACT_LIST_UPDATE
);
